module.exports = __webpack_public_path__ + "img/abs_1.19f75a9e.png";